/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */


import axios, {AxiosInstance, AxiosRequestConfig} from 'axios';
import ForgeApiConfig from "./ForgeApiConfig";
import AuthenticationContext from "adal-angular";
import GlobalStore from '../../stores/GlobalStore/GlobalStore';
/**
 * Type for Forge Axios instance
 */
export class ForgeAxiosInstance extends GlobalStore{

  /**
   * Set the auth provider for the Forge axios instance
   * @param {MsalAuthProvider} authProvider
   */
  setTokenProviderContext(authContext: AuthenticationContext) {
    this.authContext = authContext;
  }

  /**
   * Get the forge axios instance
   * @returns {AxiosInstance}
   */
  getInstance() {
    let axiosInstance = this.axiosInstance;
    if (!!axiosInstance) {
      return axiosInstance;
    }
    axiosInstance = this.axiosInstance = axios.create(ForgeApiConfig.getConfig());
    this.setBearerToken(axiosInstance);
    return axiosInstance;
  }

  /**
   * Get the cloud connector axios instance
   * @returns {AxiosInstance}
   */
  getCloudConnectorInstance() {
    let ccAxiosInstance = this.cloudConnectorAxiosInstance;
    ccAxiosInstance = this.cloudConnectorAxiosInstance = axios.create(ForgeApiConfig.getCloudConnectorConfig());
    this.setBearerToken(ccAxiosInstance);
    return ccAxiosInstance;
  }

  /**
   * Get the SimplyConnect axios instance
   * @returns {AxiosInstance}
   */
  getSimplyConnectInstance() 
  {
    if (this.simplyConnectAxiosInstance)
        return this.simplyConnectAxiosInstance;
    
    let scAxiosInstance = this.simplyConnectAxiosInstance = axios.create(ForgeApiConfig.getSimplyConnectConfig());
    this.setBearerToken(scAxiosInstance);
    return scAxiosInstance;
  }

  /**
   * Set Bearer Token in the given axios instance
   */
  private setBearerToken(axiosInstance:AxiosInstance){
    let authContext = this.authContext;
    const envVariables = window.envVariables;
    let adAudience = envVariables.AD_AUDIENCE;
    /**
     * Add the Bearer token to the request handler
     */
    axiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
      !!authContext && authContext.acquireToken(adAudience,
        (errorDesc: string | null,
         token: string | null,
         error: any) => {
          if (!!token && config.headers) { 
            config.headers.Authorization = `Bearer ${token}`;
          }
          return config;
        });
      return config;
    });
  }

  /**
   * Get the forge EPM axios instance
   * @returns {AxiosInstance}
   */
    getForgeEPMInstance() {
      const sessionStorageKey = `oidc.user:${this.envVariables.FORGE_IAM_AUTHORITY}:${this.envVariables.FC_CLIENT_ID}`;
      const accessToken = JSON.parse(sessionStorage.getItem(sessionStorageKey) || '{}')['access_token'];
      let axiosInstance = this.axiosInstance;
      if (!!axiosInstance) {
        return axiosInstance;
      }
      axiosInstance = this.axiosInstance = axios.create(ForgeApiConfig.getEPMConfig(accessToken));            
      return axiosInstance;
    }

  private authContext?: AuthenticationContext;

  private axiosInstance?: AxiosInstance;
  private cloudConnectorAxiosInstance?: AxiosInstance;
  private simplyConnectAxiosInstance?: AxiosInstance;
}

/**
 * returns the Forge Axios instance
 */
export default new ForgeAxiosInstance();


